import React from "react";
import { Clock, CheckCircle2, Loader2, Banknote, RotateCcw, CalendarClock, MinusCircle } from "lucide-react";

export const rupees = (paise) => {
  if (paise == null) return "—";
  return `₹${(paise / 100).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};

export const fmtDate = (iso, withTime = false) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const opts = withTime
    ? { day: "numeric", month: "short", hour: "numeric", minute: "2-digit", timeZone: "Asia/Kolkata" }
    : { day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Kolkata" };
  return d.toLocaleString("en-IN", opts);
};

export const STATE_META = {
  upcoming: { label: "Upcoming", cls: "bg-slate-100 text-slate-700", Icon: CalendarClock },
  pending: { label: "Pending", cls: "bg-amber-100 text-amber-800", Icon: Clock },
  available: { label: "Available for Payout", cls: "bg-emerald-100 text-emerald-800", Icon: CheckCircle2 },
  processing: { label: "Payout Processing", cls: "bg-sky-100 text-sky-800", Icon: Loader2 },
  paid_out: { label: "Paid Out", cls: "bg-[#0A2540] text-white", Icon: Banknote },
  reversed: { label: "Reversed", cls: "bg-rose-100 text-rose-800", Icon: RotateCcw },
  not_earned: { label: "Not earned", cls: "bg-slate-100 text-slate-500", Icon: MinusCircle },
};

export function StatePill({ state, testid }) {
  const m = STATE_META[state] || STATE_META.pending;
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] uppercase font-bold tracking-wider px-2 py-0.5 rounded-full ${m.cls}`} data-testid={testid}>
      <m.Icon size={10} /> {m.label}
    </span>
  );
}

export function EarningStat({ label, value, hint, accent = "white", testid }) {
  const accents = {
    navy: "bg-[#0A2540] text-white",
    gold: "bg-[#FBF4DF] text-[#0A2540] border border-[#F1E3B5]",
    emerald: "bg-emerald-50 text-emerald-900 border border-emerald-200",
    sky: "bg-sky-50 text-sky-900 border border-sky-200",
    white: "bg-white text-[#0A2540] border border-slate-200",
  }[accent];
  return (
    <div className={`rounded-2xl p-5 ${accents}`} data-testid={testid}>
      <p className="text-[11px] uppercase tracking-widest opacity-70 font-bold">{label}</p>
      <p className="mt-2 text-2xl font-extrabold" style={{ fontFamily: "Poppins" }} data-testid={`${testid}-value`}>{value}</p>
      {hint && <p className="mt-1 text-xs opacity-80">{hint}</p>}
    </div>
  );
}

export function CompactStat({ label, value, title, tone = "neutral", active = false, onClick, testid }) {
  const tones = {
    neutral: active ? "bg-[#0A2540] border-[#0A2540] text-white/80 [&>strong]:text-white" : "bg-white border-slate-200 text-slate-500 [&>strong]:text-[#0A2540]",
    rose: active ? "bg-rose-700 border-rose-700 text-white/80 [&>strong]:text-white" : "bg-rose-50 border-rose-200 text-rose-700 [&>strong]:text-rose-800",
  }[tone];
  const Tag = onClick ? "button" : "div";
  return (
    <Tag type={onClick ? "button" : undefined} onClick={onClick} aria-pressed={onClick ? active : undefined}
         className={`inline-flex items-baseline gap-1.5 rounded-full border px-3 py-1.5 text-xs transition-colors ${onClick ? "hover:border-[#0A2540]/40" : ""} ${tones}`} title={title} data-testid={testid}>
      <span className="uppercase tracking-wider font-bold text-[10px]">{label}</span>
      <strong className="font-extrabold" data-testid={`${testid}-value`}>{value}</strong>
    </Tag>
  );
}

export const PAYOUT_STATUS_LABEL = {
  requested: "Processing", under_review: "Processing", approved: "Processing", processing: "Processing",
  paid: "Paid", failed: "Failed", rejected: "Not processed", cancelled: "Cancelled", reversed: "Reversed",
};
